import moment from "moment";

export const TIMESHEET_LIST_PATH = "/rostering/timesheet";

/** Normalise API timestamps and picker values to `YYYY-MM-DD`. */
export const toTimesheetDateParam = (value) => {
  if (!value) return "";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
};

/** Sidebar / query worker ids arrive as number or string; treat them as one. */
export const sameTimesheetWorkerId = (left, right) => {
  const a = Number(left);
  const b = Number(right);
  return Number.isFinite(a) && Number.isFinite(b) && a > 0 && a === b;
};

/**
 * Open the timesheet list on a specific shift.
 *
 * The list has no `/:uuid` route. Date scopes the fetch so the row is on page
 * 1; worker is `employee_profiles.id` (the sidebar / `worker_id` key).
 */
export const buildTimesheetListHref = ({
  timesheetUuid,
  shiftDate,
  workerId,
} = {}) => {
  const params = new URLSearchParams();
  if (timesheetUuid) params.set("timesheet", String(timesheetUuid));
  const date = toTimesheetDateParam(shiftDate);
  if (date) params.set("date", date);
  const worker = Number(workerId);
  if (Number.isFinite(worker) && worker > 0) {
    params.set("worker", String(worker));
  }
  const query = params.toString();
  return query ? `${TIMESHEET_LIST_PATH}?${query}` : TIMESHEET_LIST_PATH;
};

/** Read Care Watch (or any) deep-link off `location.search`. */
export const parseTimesheetDeepLink = (search) => {
  const raw = typeof search === "string" ? search.replace(/^\?/, "") : "";
  if (!raw) return null;

  const params = new URLSearchParams(raw);
  const timesheetUuid = (params.get("timesheet") || "").trim() || null;
  const date = toTimesheetDateParam(params.get("date")) || null;
  const worker = Number(params.get("worker"));
  const workerId = Number.isFinite(worker) && worker > 0 ? worker : null;

  if (!timesheetUuid && !date && !workerId) return null;
  return { timesheetUuid, date, workerId };
};
